import { useState, useContext, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { IBilling } from 'domain/entities/Billing/Billing';
import { CompanyBillingQuery } from 'interfaceAdapter/queries/CompanyBilling';

export const useBilling = () => {
    const diContainer = useContext(diContainerContext);
    const companyBillingQuery = diContainer.resolve(CompanyBillingQuery);
    const [billingList, setBillingList] = useState<IBilling[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await companyBillingQuery.fetchList();
            setBillingList(data);
        };
        fetchData();
    }, []);

    return { billingList };
};
